import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../../lib/theme';
import { v1Users } from '../../../lib/v1';
import { type RatingRow } from './types';
import { fmtDate } from './helpers';
import { WidgetCard } from './WidgetCard';

/* ─── BewertungenWidget (compact) ─────────────────────────────────────────── */

export function BewertungenWidget({ dark, userId, userRole, onShowAll }: { dark: boolean; userId: number; userRole: number; onShowAll: (e: React.MouseEvent) => void }) {
  const { t } = useTranslation();
  const tc = getThemeColors(dark);
  const [ratings, setRatings] = useState<RatingRow[]>([]);
  const [total, setTotal] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    v1Users.ratingsReceived(userId, { perPage: 3, filters: { user_role: String(userRole) } })
      .then(p => { if (alive) { setRatings((p.data as unknown as RatingRow[]).slice(0, 3)); setTotal(p.total ?? p.data.length); } })
      .catch(() => {/* ignore */})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [userId, userRole]);

  const renderStars = (val: number | null | undefined) => {
    const v = Math.round(val ?? 0);
    return Array.from({ length: 5 }).map((_, i) => (
      <span key={i} style={{ color: i < v ? '#f79009' : tc.border, fontSize: 12 }}>★</span>
    ));
  };

  return (
    <WidgetCard dark={dark} title={t('pflege.detail.dashboard.bewertungen')} badge={total} onShowAll={onShowAll} showAllLabel={t('pflege.detail.dashboard.alle_anzeigen')} loading={loading}>
      <div>
        {!loading && ratings.length === 0 && <div style={{ padding: '10px 14px', fontSize: 12, color: tc.muted, fontStyle: 'italic' }}>{t('pflege.ratings.empty_received')}</div>}
        {ratings.map(r => (
          <div key={r.id} style={{ padding: '8px 14px', borderBottom: `1px solid ${tc.borderSoft}` }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: 12.5, fontWeight: 500, color: tc.heading }}>{r.von_name ?? t('pflege.ratings.user_fallback', { id: '—' })}</div>
              <div>{renderStars(r.rating_gesamt)}</div>
            </div>
            {r.created_at && <div style={{ fontSize: 10.5, color: tc.muted, marginTop: 1 }}>{fmtDate(r.created_at)}</div>}
          </div>
        ))}
      </div>
    </WidgetCard>
  );
}
